import axios from 'axios';
import store from '@/store';
import { Message } from 'element-ui';
import { isCheckTimeout } from '@/utils/timeStamp';
import { BASEURL } from '@/constant';

const service = axios.create({
  baseURL: BASEURL,
  timeout: 5000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在这个位置需要统一的去注入token
    if (config.isUser && !store.getters.token) {
      // isUser需要登录
      const message = '请先登录';
      return Promise.reject({ code: 401, message });
    }
    if (store.getters.token) {
      if (isCheckTimeout()) {
        Message.error('身份过期，请重新登录');
        const timer = setTimeout(() => {
          store.dispatch('user/logout');
        }, 1000);
        return Promise.reject(new Error('token失效'));
      }
      // 如果token存在 注入token
      config.headers.Authorization = `Bearer ${store.getters.token}`;
    }
    return config; // 必须返回配置
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const { success, message, code } = response.data;
    // token失败过期被动处理被动失败
    if (code === '401' || code === 'A0230') {
      const timer = setTimeout(() => {
        clearTimeout(timer);
        store.dispatch('user/logout');
      }, 800);
    }
    //   要根据success的成功与否决定下面的操作
    // if (response.data.access_token) {
    //   return response.data
    // } else if (success) {
    //   return data
    // } else {
    //   // 业务错误
    //   Message.error(message || '网络异常') // 提示错误消息
    //   return Promise.reject(new Error(message))
    // }
    if (!success && message) {
      Message.error(message || '网络异常');
      return Promise.reject(new Error(message));
    }
    return Promise.resolve(response.data);
  },
  (error) => {
    error.message && Message.error(error.message || '网络异常');
    return Promise.reject(error);
  },
);

export default service;
